var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E9D502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D502 "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M35.082,44.621V38.456a1.02,1.02,0,0,0-.318-.763,1.044,1.044,0,0,0-.752-.308H27.591a1.044,1.044,0,0,0-.752.308,1.02,1.02,0,0,0-.318.763v6.166a1.02,1.02,0,0,0,.318.763,1.044,1.044,0,0,0,.752.308h6.421a1.044,1.044,0,0,0,.752-.308A1.02,1.02,0,0,0,35.082,44.621Zm-.067-12.137.6-14.9a.709.709,0,0,0-.334-.617,1.311,1.311,0,0,0-.8-.357H27.122a1.311,1.311,0,0,0-.8.357.769.769,0,0,0-.334.681l.569,14.831a.621.621,0,0,0,.334.535,1.474,1.474,0,0,0,.8.211h6.187a1.39,1.39,0,0,0,.786-.211A.719.719,0,0,0,35.015,32.484Zm-.468-30.31L60.232,47.867a3.774,3.774,0,0,1-.067,4.089,4.144,4.144,0,0,1-1.555,1.493A4.281,4.281,0,0,1,56.487,54H5.116a4.281,4.281,0,0,1-2.124-.552,4.144,4.144,0,0,1-1.555-1.493,3.774,3.774,0,0,1-.067-4.089L27.056,2.174A4.2,4.2,0,0,1,28.627.584a4.337,4.337,0,0,1,4.348,0A4.2,4.2,0,0,1,34.547,2.174Z",
    transform: "translate(-0.801)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warningYellow.ae41e0fdc6d44dd45a2089b619bd6a65.svg";
export { ForwardRef as ReactComponent };